import gql from 'graphql-tag';

export default gql`
    mutation DeleteCustomer($input: CustomerDeleteRequest) {
        deleteCustomer(input: $input) {
            errors
        }
    }
`;
